import { getTechonologies, TECHONOLOGIES } from "./technologies.data";

export const experiences = [
  {
    id:1,
    name: "Smart Runners Ltd.",
    year: "2024-Now",
    children: [
      {
        name: "Currently collaborating closely with their skilled and supportive team, I assist in meeting deadlines through fast-paced development and debugging.",
        technologies:getTechonologies(TECHONOLOGIES.LARAVEL,TECHONOLOGIES.EXPRESSJS,TECHONOLOGIES.REACT,TECHONOLOGIES.ANGULAR,TECHONOLOGIES.PHPUNIT,TECHONOLOGIES.DOCKER),

      },
    ],
  },
  {
    id:2,
    name: "Barg Talai Parmis Pvt Ltd.",
    year: "2021",
    children: [
      {
        name: "I collaborated independently with them to develop three applications. The first application enables ambassadors to place and fulfill orders, while the second focuses on logistics, allowing trucks to efficiently deliver products to ambassadors. Lastly, a management system for their manufacturing facility to oversee product inventory, along with an attractive landing page for customers to easily purchase and track their orders.",
        technologies:getTechonologies(TECHONOLOGIES.LARAVEL,TECHONOLOGIES.JQUERY,TECHONOLOGIES.UIUX,TECHONOLOGIES.WEBSOCKET,TECHONOLOGIES.NGINX),
      },
    ],
  },
  {
    id:3,
    name: "Parseh Farsad Aria Ltd.",
    year: "2018-2020",
    children: [
      {
        name: "I developed sales pipelines for them to facilitate selling their stock to business customers, allowing these clients to pay a portion upfront and the remainder in installments. Given that their product required a lengthy verification process involving laboratory tests and customs procedures, I ensured that the system accommodated these complexities. Additionally, I independently integrated their internal processes, including custom accounting and hierarchical approvals, into the startup’s framework.",
        technologies:getTechonologies(TECHONOLOGIES.LARAVEL,TECHONOLOGIES.JQUERY,TECHONOLOGIES.WEBSOCKET,TECHONOLOGIES.APACHE,TECHONOLOGIES.REACTNATIVE),
      },
    ],
  },
];
